import React from 'react';
import TopNavbar from "./TopNavbar";
import TableForEdit from "./TableForEdit";

function WaitingPage() {
    return (
        <>
            <div className={'main-info-container'}>
                <div className={'top-invites-container flex'}>
                    <div className={'invites-header-container flex'}>
                        <div className={'sum-of-invites'}>12P</div>
                        <h2>רשימת המתנה</h2>
                        <div className={'search-fillter-container flex'}>
                            <button>סנן לפי שעה</button>
                            <input type={"search"} placeholder={'חיפוש...'}/>
                        </div>
                    </div>
                    <TableForEdit/>
                </div>
            </div>

        </>    );
}

export default WaitingPage;